import { styled } from '@mui/material/styles';
import { Panel } from 'src/UIKit';

export const ChatScheduledMessagePanel = styled(Panel)(({ theme }) => ({
  '&&': { padding: theme.spacing(1, 1.25) },
}));
